import React, { useState, useEffect, useContext } from "react";
import { Redirect, Link } from "react-router-dom";
import { Icon, notification } from "antd";
import { GeralContext } from "../ContextProvider";
import { GlobalContext } from "../../app/providers/GlobalState";
import Card from "../Participantes/Participante";
import DrawerFicha from "./Drawer/DrawerFicha";
import ModalFicha from "./Modal/ModalFicha";
import ModalViewer from "../../shared/components/Modals/ModalViewer";
import axios from "axios";
import ModalLoading from "../../shared/components/Modals/ModalLoading";

import Participante from "../Participantes/Participante";
import DrawerNotificar from "../Participantes/Drawers/DrawerNotificar";

import ModalGerarDocumento from "../../shared/components/Modals/GerarDocumento";

import Acessos from "../../Geral/Acessos/Acessos";

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const VisaoGeralDisciplina = ({ match }) => {
    const globalContext = useContext(GlobalContext);
    const [professores, setProfessores] = useState([]);
    const [ficha, setFicha] = useState("");
    const [fichaValidada, setFichaValidada] = useState(false);
    const [permissao, setPermissao] = useState(false);
    const [loading, setLoading] = useState(false);
    const [visible, setVisible] = useState(false);
    const [visibleAlunos, setVisibleAlunos] = useState(false);
    const [visibleModal, setVisibleModal] = useState(false);
    const [redirect, setRedirect] = useState(false);
    const [redirectLink, setRedirectLink] = useState("");
    const [visibleLoading, setVisibleLoading] = useState(false);
    const [visibleViewer, setVisibleViewer] = useState(false);
    const [docs, setDocs] = useState([]);

    const [alunos, setAlunos] = useState("");
    const [participantes, setParticipantes] = useState([]);
    const [visibleExport, setVisibleExport] = useState(false);
    const [buttonDownload, setButtonDownload] = useState(false);
    const [exportFile, setExportFile] = useState("");

    const context = useContext(GeralContext);

    const listarProfessores = () => {
        setLoading(true);
        axios({
            method: "get",
            url: "/api/turma/lista-professores",
            params: {
                id: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                setProfessores(response.data);
                setLoading(false);
            })
            .catch(error => {
                if (error.response?.status === 401) {
                    setRedirectLink("/login");
                    setRedirect(true);
                }

                setLoading(false);
            });
    };

    const carregarFicha = () => {
        axios({
            method: "get",
            url: "/api/turma/listar-ficha",
            params: {
                id: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                setPermissao(
                    response.data.coordenador || globalContext.perfil?.nome == "Suporte" || globalContext.perfil?.nome == "Gestor"
                );
                setFicha(response.data.ficha);
                setFichaValidada(response.data.ficha_validada);
            })
            .catch(() => {});
    };

    const montarBotaoVoltar = () => {
        if (localStorage.getItem("opcao_voltar") != null) {
            const opcaoInfo = JSON.parse(localStorage.getItem("opcao_voltar"));
            return (
                <Link
                    to={opcaoInfo.link_voltar_curso ? opcaoInfo.link_voltar_curso : opcaoInfo.link_voltar}
                    className="botao-secundario botao-secundario-redondo"
                    onClick={() => opcaoInfo.id_curso && localStorage.setItem("codigo_curso", opcaoInfo.id_curso)}
                    style={{ marginRight: 10, display: "flex", justifyContent: "center", alignItems: "center" }}
                >
                    <Icon type="arrow-left" />
                </Link>
            );
        }
    };

    const gerarDoc = () => {
        setVisibleLoading(true);
        axios({
            method: "get",
            url: "/api/pdf/ficha-curricular",
            params: {
                cursoId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                const { url, fileName } = response.data;

                setVisibleLoading(false);
                setDocs([{ uri: url, fileName }]);
                setVisibleViewer(true);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível gerar documento!");
                setVisibleLoading(false);
            });
    };

    const titulosDetalheMenu = () => {
        axios({
            method: "get",
            url: "/api/turma/titulos-detalhe-menu",
            timeout: 60 * 10 * 1000,
            params: {
                cursoId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                setAlunos(response.data.alunos);
            })
            .catch(() => {});
    };

    useEffect(() => {
        listarProfessores();
        titulosDetalheMenu();
        listar(localStorage.getItem("codigo_curso"));
    }, []);

    useEffect(() => {
        if (globalContext.perfil?.id) carregarFicha();
    }, [globalContext.perfil]);

    const listar = async turmaId => {
        setLoading(true);
        try {
            const response = await axios.get("/api/turma/lista-alunos", { params: { turmaId } });
            setParticipantes(response.data);
        } catch (error) {
            if (error.response?.status === 401) {
                setRedirect(true);
                setRedirectLink("/login");
            }
        } finally {
            setLoading(false);
        }
    };

    const exportarPdf = async () => {
        setVisibleLoading(true);
        try {
            const response = await axios.get("/api/aulas-exportar/listagem-alunos-pdf", {
                params: { id: localStorage.getItem("codigo_curso") }
            });

            const { url, fileName } = response.data;

            setDocs([{ uri: url, fileName }]);
            setVisibleViewer(true);
        } catch {
            openNotificationWithIcon("error", "Erro", "Não foi possível exportar!");
        } finally {
            setVisibleLoading(false);
        }
    };

    const exportarCsv = async () => {
        setVisibleExport(true);
        setButtonDownload(true);
        try {
            const response = await axios.get("/api/aulas-exportar/listagem-alunos", {
                params: { id: localStorage.getItem("codigo_curso") }
            });
            setExportFile(response.data);
        } catch {
            openNotificationWithIcon("error", "Erro", "Não foi possível exportar!");
        } finally {
            setButtonDownload(false);
        }
    };

    if (redirect) return <Redirect to={redirectLink} />;

    const acesso = globalContext.acessos?.find(x => x.func === 16);

    return (
        <>
            <GeralContext.Consumer>
                {geralContext => {
                    return (
                        <>
                            <Acessos funcionalidadeId={16} />
                            <div className="container container-body">
                                {loading ? (
                                    <div className="loading-data">
                                        <div className="loading" />
                                    </div>
                                ) : (
                                    <div className="turma-visao-geral">
                                        <div className="controlos controlos-fundo" style={{ justifyContent: "flex-end" }}>
                                            <div className="bloco-direita">{montarBotaoVoltar()}</div>
                                        </div>
                                        <div className="bloco esquerda">
                                            <div className="item">
                                                <div className="lista-professores">
                                                    {professores.map(professor => (
                                                        <Card
                                                            {...professor}
                                                            key={professor.id}
                                                            dt_fechado={context.dt_fechado}
                                                            dt_inicio={context.dt_inicio}
                                                            dt_fim={context.dt_fim}
                                                            fechado={context.fechado}
                                                            perfil={professor.coordenador ? "Coordenador" : "Professor"}
                                                        />
                                                    ))}
                                                </div>
                                            </div>
                                            {context.temFicha && (
                                                <div className="bloco esquerda bloco-ficha">
                                                    <div className="item">
                                                        <h2>
                                                            <span className="bloco-ficha-titulos">
                                                                <span>Ficha</span>
                                                                {!fichaValidada && (
                                                                    <i className="bloco-ficha-aguarda">Aguarda validação...</i>
                                                                )}
                                                            </span>
                                                            <span className="bloco-ficha-opcoes">
                                                                {permissao && !fichaValidada && acesso?.update && (
                                                                    <>
                                                                        <Link
                                                                            className="botao-icon-editar"
                                                                            to="#"
                                                                            title="Editar"
                                                                            onClick={() => setVisible(true)}
                                                                        >
                                                                            <Icon type="edit" />
                                                                        </Link>
                                                                        <Link
                                                                            className="botao-icon-check"
                                                                            to="#"
                                                                            title="Validar"
                                                                            onClick={() => setVisibleModal(true)}
                                                                        >
                                                                            <Icon type="check" />
                                                                        </Link>
                                                                    </>
                                                                )}
                                                                <Link
                                                                    className="botao-icon-detalhe"
                                                                    to="#"
                                                                    title="Descarregar"
                                                                    onClick={gerarDoc}
                                                                >
                                                                    <Icon type="eye" />
                                                                </Link>
                                                            </span>
                                                        </h2>
                                                        <div className="lista-campos-ficha">
                                                            {ficha?.estrutura?.map((campo, index) => (
                                                                <div key={index} className="campo-ficha">
                                                                    <h3>{campo.nome}</h3>
                                                                    {campo.texto && (
                                                                        <p
                                                                            dangerouslySetInnerHTML={{
                                                                                __html: campo.texto.replace(/\n/g, "<br>")
                                                                            }}
                                                                        ></p>
                                                                    )}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}
                                <DrawerFicha
                                    visible={visible}
                                    onClose={() => setVisible(false)}
                                    atualizar={() => {
                                        setVisible(false);
                                        carregarFicha();
                                    }}
                                />
                                <ModalFicha
                                    visible={visibleModal}
                                    onClose={() => setVisibleModal(false)}
                                    atualizar={() => {
                                        setVisibleModal(false);
                                        carregarFicha();
                                    }}
                                />
                                <ModalLoading visible={visibleLoading} text="A gerar documento..." />
                                <ModalViewer visible={visibleViewer} docs={docs} onCancel={() => setVisibleViewer(false)} />

                                <div className="curso-resultados">
                                    <div className="controlos controlos-fundo" style={{ flex: 1 }}>
                                        <div
                                            className="bloco-esquerda"
                                            style={{ justifyContent: "flex-start", fontSize: 20, paddingLeft: 16, fontWeight: "bold" }}
                                        >
                                            {alunos} ({participantes.length})
                                        </div>

                                        <div className="bloco-direita" style={{ justifyContent: "flex-end" }}>
                                            <Link to="#" className="botao-icon-enviar botao-maior" onClick={() => setVisibleAlunos(true)}>
                                                <Icon type="mail" />
                                            </Link>
                                            <Link
                                                to="#"
                                                className="botao-icon-detalhe botao-maior"
                                                title="Visualizar"
                                                onClick={exportarPdf}
                                            >
                                                <Icon type="eye" />
                                            </Link>
                                            <Link
                                                to="#"
                                                className="botao-icon-download botao-maior"
                                                title="Descarregar"
                                                onClick={exportarCsv}
                                            >
                                                <Icon type="download" />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="curso-participantes" style={loading ? { display: "block" } : {}}>
                                    {loading ? (
                                        <div className="loading-data">
                                            <div className="loading" />
                                        </div>
                                    ) : (
                                        participantes.map((participante, index) => (
                                            <Participante
                                                {...participante}
                                                key={index}
                                                dt_fechado={geralContext.dt_fechado}
                                                dt_inicio={geralContext.dt_inicio}
                                                dt_fim={geralContext.dt_fim}
                                                fechado={geralContext.fechado}
                                                responsaveis_entidade={globalContext.responsaveis_entidade}
                                                conf_total_participantes={globalContext.conf_total_participantes}
                                                habilitar_gamificacao={
                                                    geralContext.habilitar_gamificacao && globalContext.gamificacao_entidade
                                                }
                                                perfil="Aluno"
                                            />
                                        ))
                                    )}
                                </div>
                                <DrawerNotificar
                                    visible={visibleAlunos}
                                    onClose={() => setVisibleAlunos(false)}
                                    total={participantes.length}
                                />
                                <ModalGerarDocumento
                                    visibleExportar={visibleExport}
                                    ficheiroExportar={exportFile}
                                    btnDescarregar={buttonDownload}
                                    onClose={() => setVisibleExport(false)}
                                />
                                <ModalLoading visible={visibleLoading} text="A gerar documento..." />
                                <ModalViewer visible={visibleViewer} docs={docs} onCancel={() => setVisibleViewer(false)} />
                            </div>
                        </>
                    );
                }}
            </GeralContext.Consumer>
        </>
    );
};
export default VisaoGeralDisciplina;
